import React, { useState } from "react";
import LoginFooter from "../components/Footer/LoginFooter";
import { LoginServices } from "../services/LoginServices";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import Notification from "../components/Notifications/Notification";
import CircularProgress from "@mui/material/CircularProgress";
import {LogsServices} from "../services/LogsServices";

const LoginPage = () => {
  const [viewPass, setViewPass] = useState(false);
  const [opened, setOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    login: "",
    password: "",
    rememberPassword: false,
  });

  function handleInputChange(event) {
    const { name, value, type, checked } = event.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormData({
      ...formData,
      [name]: fieldValue,
    });
  }

  function handleLoginSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    const { login, password } = formData;
    LoginServices.login(login, password)
      .then(async (response) => {
        if (response === undefined) {
          await LogsServices.postLog(`Login: Login bem-sucedido do usuário ${login}`);
          window.location.href = "/";
        } else {
          handleAlert();
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const handleAlert = () => {
    setOpened(true);
    setTimeout(() => {
      setOpened(false);
    }, 3000);
  };

  return (
    <>
      <div className="flex flex-col justify-between h-screen">
        <div className="flex flex-row w-full h-full">
          <div
            className="h-full w-1/2 bg-cover bg-center hidden md:block"
            style={{
              background: `linear-gradient(rgba(21, 120, 66, 0.3), rgba(21, 120, 66, 0.5)), url(${
                process.env.PUBLIC_URL + "/medico.jpg"
              })`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="flex flex-col mx-auto my-auto justify-center items-center">
            <img
              src={process.env.PUBLIC_URL + "/logo.svg"}
              alt="logo"
              className="w-40 h-40 mb-12"
            />
            <h1 className="font-bold text-2xl text-gray-700 pb-6">
              Area de autenticação
            </h1>
            <form onSubmit={handleLoginSubmit}>
              <label className="pb-6 text-gray-600">Email</label>
              <br />
              <input
                type="text"
                name="login"
                value={formData.login}
                onChange={handleInputChange}
                placeholder="administrador@gmail.com"
                className="w-96 py-2 px-2 border-2 text-md border-gray-300 mb-4 mt-2 rounded placeholder-gray-200 font-light"
                disabled={isLoading}
              />
              <br />
              <label className="text-gray-600">Password</label> <br />
              <div className="relative">
                <input
                  type={viewPass ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="*********"
                  className="w-96 py-2 px-2 border-2 text-md border-gray-300 mb-4 mt-2 rounded placeholder-gray-200 font-light"
                  disabled={isLoading}
                />
                {!isLoading &&
                  (viewPass ? (
                    <VisibilityOff
                      style={{ width: "20px", height: "20px" }}
                      className="absolute right-0 top-0 mt-5 mr-3 cursor-pointer text-xs text-gray-600"
                      onClick={() => setViewPass(!viewPass)}
                    />
                  ) : (
                    <Visibility
                      style={{ width: "20px", height: "20px" }}
                      className="absolute right-0 top-0 mt-5 mr-3 cursor-pointer text-xs text-gray-600"
                      onClick={() => setViewPass(!viewPass)}
                    />
                  ))}
              </div>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  name="rememberPassword"
                  checked={formData.rememberPassword}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  className="mr-2"
                />
                <label> Lembrar minha senha </label>
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className={`w-full py-4 font-bold text-white rounded-lg mt-8 flex items-center justify-center ${
                  isLoading
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-green-800 hover:bg-green-900 cursor-pointer"
                }`}
              >
                {isLoading ? (
                  <>
                    <CircularProgress
                      size={20}
                      style={{ color: "white", marginRight: "8px" }}
                    />
                    Carregando...
                  </>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </div>
        </div>

        {opened && (
          <Notification
            type="warning"
            title={"Usuário ou senha Inválidos"}
            message={"Tente novamente ou contate um administrador!"}
          />
        )}
        <LoginFooter />
      </div>
    </>
  );
};

export default LoginPage;
